/**
 * VideoReviews — кастомный HTML-элемент <video-reviews>
 *
 * Предоставляет:
 *   - Карусель видео-превью (Swiper)
 *   - Попап-лайтбокс с управлением видео
 *
 * Использование:
 *   <video-reviews class="video-reviews">
 *     ... (см. video-reviews.html)
 *   </video-reviews>
 */
class VideoReviews extends HTMLElement {
  constructor() {
    super();
    this.muteButton = this.querySelector('#muteButton');
    this.unmuteButton = this.querySelector('#unmuteButton');
    this.videos = this.querySelectorAll('.video-item video');
    this.videoReviewsWrapper = this.querySelector('.video-reviews__wrapper');
    this.popup = this.querySelector('.video-popup');
    this.popupVideo = this.popup.querySelector('video');
    this.iconPlay = this.querySelector('.play-stop');
    this.videoClose = this.popup.querySelector('.close-btn');
    this.progressBar = this.querySelector('#progressBar');
    this.currentVideoIndex = 0;
  }

  connectedCallback() {
    this.videoInit();
  }

  videoInit() {
    // Клик по превью — открыть попап с соответствующим видео
    this.videos.forEach((video, index) => {
      video.addEventListener('click', () => {
        this.currentVideoIndex = index;
        this.openPopupWithVideo(index);
      });
    });

    // Опционально: play на hover (data-play-on-hover="true")
    if (this.dataset.playOnHover === 'true') {
      this.videos.forEach((video) => {
        video.addEventListener('mouseenter', () => {
          video.play().catch(() => {});
        });
        video.addEventListener('mouseleave', () => {
          video.pause();
        });
      });
    }

    // Опционально: кастомный курсор (data-cursor)
    const cursorText = this.querySelector('.video-hover-text');
    if (this.querySelector('[data-cursor]') && cursorText) {
      this.videos.forEach((video) => {
        const item = video.closest('.video-item');
        video.addEventListener('mouseover', () => {
          cursorText.textContent = item.dataset.cursor;
          cursorText.style.display = 'block';
        });
        video.addEventListener('mousemove', (e) => {
          cursorText.style.top = e.clientY + 10 + 'px';
          cursorText.style.left = e.clientX + 10 + 'px';
        });
        video.addEventListener('mouseout', () => {
          cursorText.style.display = 'none';
        });
      });
    }

    // Логика попапа
    this.popupVideo.addEventListener('click', () => {
      if (this.popupVideo.paused) {
        this.popupVideo.play();
        this.iconPlay.style.display = 'none';
      } else {
        this.popupVideo.pause();
        this.iconPlay.style.display = 'block';
      }
    });

    this.iconPlay.addEventListener('click', () => {
      this.popupVideo.play();
      this.iconPlay.style.display = 'none';
    });

    this.muteButton.addEventListener('click', () => {
      this.popupVideo.muted = true;
      this.muteButton.style.display = 'none';
      this.unmuteButton.style.display = 'flex';
    });

    this.unmuteButton.addEventListener('click', () => {
      this.popupVideo.muted = false;
      this.muteButton.style.display = 'flex';
      this.unmuteButton.style.display = 'none';
    });

    this.videoClose.addEventListener('click', () => {
      this.closePopup();
    });

    // Закрыть при клике вне попапа
    document.addEventListener('click', (e) => {
      if (
        !this.popup.contains(e.target) &&
        !this.videoReviewsWrapper.contains(e.target)
      ) {
        this.closePopup();
      }
    });

    // Авто-переход к следующему видео по окончании
    this.popupVideo.addEventListener('ended', () => {
      this.currentVideoIndex =
        this.currentVideoIndex < this.videos.length - 1
          ? this.currentVideoIndex + 1
          : 0;
      this.openPopupWithVideo(this.currentVideoIndex);
    });

    // Прогресс-бар
    this.popupVideo.addEventListener('timeupdate', () => {
      const progress =
        (this.popupVideo.currentTime / this.popupVideo.duration) * 100;
      if (!isNaN(progress) && isFinite(progress)) {
        this.progressBar.value = progress;
      }
    });
  }

  openPopupWithVideo(index) {
    const video = this.videos[index];
    const source = video.querySelector('source');
    const src = (source || video).getAttribute('src');

    if (!src) return;

    this.popup.classList.add('active');
    this.popupVideo.src = src;
    this.popupVideo.muted = false;
    this.popupVideo.play();
    this.iconPlay.style.display = 'none';
    this.muteButton.style.display = 'flex';
    this.unmuteButton.style.display = 'none';

    // Очистить блок товара (если используется)
    const productBlock = this.popup.querySelector('.video-popup__product');
    if (productBlock) productBlock.innerHTML = '';
  }

  closePopup() {
    this.popup.classList.remove('active');
    this.popupVideo.pause();
    this.popupVideo.src = '';
  }
}

customElements.define('video-reviews', VideoReviews);
